import React from 'react';
import { Divider } from 'semantic-ui-react'

const ProcAdm1 = ({autorizacUA, styles, handleClickRegr, handleClickArchCarAdic, handleClickSel1, handleClickSel2,
  handleClickAjPos, handleClickSel3, handleClickSelClNd, handleClickSCliNu, handleClickSCliUpd, handleClickOSDX,
  handleClickOSSinCamb, handleClickTCUpd}) => {

  // const a102501 = autorizacUA.findIndex( autorizac => autorizac === "102501" );
  // const a102505 = autorizacUA.findIndex( autorizac => autorizac === "102505" );
  const a102505 = autorizacUA.findIndex( autorizac => autorizac === "102505" );
  const a102510 = autorizacUA.findIndex( autorizac => autorizac === "102510" );
  const a102515 = autorizacUA.findIndex( autorizac => autorizac === "102515" );
  const a102516 = autorizacUA.findIndex( autorizac => autorizac === "102516" );
  const a102517 = autorizacUA.findIndex( autorizac => autorizac === "102517" );
  const a102520 = autorizacUA.findIndex( autorizac => autorizac === "102520" );
  const a102525 = autorizacUA.findIndex( autorizac => autorizac === "102525" );
  const a102530 = autorizacUA.findIndex( autorizac => autorizac === "102530" );
  const a102535 = autorizacUA.findIndex( autorizac => autorizac === "102535" );
  const a102545 = autorizacUA.findIndex( autorizac => autorizac === "102545" );
  const a102550 = autorizacUA.findIndex( autorizac => autorizac === "102550" );
  
  return (
    <div>
      <button className="ui right labeled icon button fluid" style={styles.titBuscar}>
        <i className="large sitemap yellow icon"></i>
        Opciones
      </button>

      <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickRegr}>
        <i className="large arrow left violet icon"></i>
        Regresar
      </button>
      
      <Divider inverted />

      {a102505!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickArchCarAdic}>
          <i className="large dollar sign violet icon"></i>
          Procesar archivo cargos adicionales
        </button>
      }

      <Divider inverted />

      {a102510!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel3}>
          <i className="large dollar sign violet icon"></i>
          Procesar archivo notas crédito
        </button>
      }

      {a102515!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel2}>
          <i className="large dollar sign violet icon"></i>
          Procesar archivo aj negativos
        </button>
      }

      {a102516!==-1 &&
        <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickAjPos}>
          <i className="large dollar sign violet icon"></i>
          Procesar archivo aj positivos
        </button>
      }

      {a102517!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSelClNd}>
            <i className="large edit violet icon"></i>
            Actualizar clientes con el nodo
          </button>
        </div>
      }

      {a102520!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSel1}>
            <i className="large edit violet icon"></i>
            Cambiar número de contrato
          </button>
        </div>
      }
      {a102525!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSCliNu}>
            <i className="large edit violet icon"></i>
            Procesar archivo Clientes NUEVOS
          </button>
        </div>
      }
      {a102530!==-1 &&
        <div>
          <Divider inverted />

          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickOSDX}>
            <i className="large edit violet icon"></i>
            Procesar archivo OS DX
          </button>
        </div>
      }
      {a102535!==-1 &&
        <div>
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickOSSinCamb}>
            <i className="large edit violet icon"></i>
            Procesar archivo OS de COBRO/RET EQ/CAMB VELOC
          </button>
        </div>
      }
      {a102545!==-1 &&
        <div>
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickSCliUpd}>
            <i className="large edit violet icon"></i>
            Procesar archivo ACTUALIZAR Clientes
          </button>
        </div>
      }
      {a102550!==-1 &&
        <div>
          <button className="ui labeled icon button fluid" style={styles.dropdown} onClick={handleClickTCUpd}>
            <i className="large edit violet icon"></i>
            Procesar archivo TIPOS DE CLIENTE
          </button>
        </div>
      }

    </div>
  )
};

export default ProcAdm1
